<template>
  <v-tooltip :bottom="bottom" :top="top" :color="color">
    <template #activator="{ on, attrs }">
      <span v-bind="attrs" :class="itemClass" v-on="on">
        <slot name="activator">
          <v-icon v-if="icon" :color="iconColor" :size="size">{{
            icon
          }}</v-icon>
          <span v-else> {{ text }}</span>
        </slot>
      </span>
    </template>
    <slot>
      <span>
        {{ tooltipText }}
      </span>
    </slot>
  </v-tooltip>
</template>

<script>
  export default {
    name: 'InfoTooltip',
    props: {
      text: {
        type: String,
        default: '',
      },
      tooltipText: {
        type: String,
        default: '',
      },
      icon: {
        type: String,
        default: '',
      },
      iconColor: {
        type: String,
        default: 'primary',
      },
      size: {
        type: [String, Number],
        default: 24,
      },
      itemClass: {
        type: [String, Object, Array],
        default: '',
      },
      top: {
        type: Boolean,
        default: true,
      },
      color: {
        type: String,
        default: '',
      },
      bottom: Boolean,
    },
  };
</script>
